"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = exports.Action = exports.Content = exports.Section = exports.Root = void 0;
const styles_1 = require("@mui/material/styles");
const typography_1 = __importDefault(require("../typography"));
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    padding: "30px",
    [theme.breakpoints.down("lg")]: {
        padding: "30px 20px"
    }
}));
exports.Section = (0, styles_1.styled)("div")({
    "&:not(:first-of-type)": {
        marginTop: "24px"
    }
});
exports.Content = (0, styles_1.styled)("div")(({ theme }) => ({
    marginTop: "16px",
    [theme.breakpoints.up("lg")]: {
        marginTop: "24px"
    }
}));
exports.Action = (0, styles_1.styled)("div")(({ theme }) => ({
    marginTop: "16px",
    [theme.breakpoints.up("lg")]: {
        marginBottom: "24px"
    }
}));
exports.Heading = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    marginBottom: "16px",
    [theme.breakpoints.up("lg")]: {
        marginBottom: "24px"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Bvc3QtaXQtY2FyZC9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLCtEQUF1QztBQUUxQixRQUFBLElBQUksR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDaEQsT0FBTyxFQUFFLE1BQU07SUFDZixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDOUIsT0FBTyxFQUFFLFdBQVc7S0FDckI7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsT0FBTyxHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ25DLHVCQUF1QixFQUFFO1FBQ3ZCLFNBQVMsRUFBRSxNQUFNO0tBQ2xCO0NBQ0YsQ0FBQyxDQUFDO0FBRVUsUUFBQSxPQUFPLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ25ELFNBQVMsRUFBRSxNQUFNO0lBQ2pCLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM1QixTQUFTLEVBQUUsTUFBTTtLQUNsQjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxNQUFNLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2xELFNBQVMsRUFBRSxNQUFNO0lBQ2pCLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM1QixZQUFZLEVBQUUsTUFBTTtLQUNyQjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxPQUFPLEdBQUcsSUFBQSxlQUFNLEVBQUMsb0JBQVUsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUN4RCxZQUFZLEVBQUUsTUFBTTtJQUNwQixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDNUIsWUFBWSxFQUFFLE1BQU07S0FDckI7Q0FDRixDQUFDLENBQUMsQ0FBQyJ9